var _g, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "11 2 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7384_62294)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3.875,
    width: 13.75,
    height: 16.25,
    rx: 0.625,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3.875,
    width: 6.875,
    height: 3.75,
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.875,
    y: 3.875,
    width: 6.875,
    height: 3.75,
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 7.625,
    width: 6.875,
    height: 4.375,
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.875,
    y: 7.625,
    width: 6.875,
    height: 4.375,
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 6.875,
    height: 3.75,
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.875,
    y: 12,
    width: 6.875,
    height: 3.75,
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15.75,
    width: 6.875,
    height: 4.375,
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.875,
    y: 15.75,
    width: 6.875,
    height: 4.375,
    fill: "#185C37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_7384_62294)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 7,
    width: 9.375,
    height: 9.375,
    rx: 0.625,
    fill: "#17864D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6005 14.25L16.518 11.5687L14.6005 8.855H15.8274L17.1355 10.7075L18.4599 8.855H19.6461L17.7205 11.5362L19.6461 14.25H18.4274L17.103 12.3894L15.7705 14.25H14.6005Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_7384_62294",
    x: 0.75,
    y: 0.75,
    width: 34.375,
    height: 34.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7384_62294"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7384_62294",
    result: "effect2_dropShadow_7384_62294"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_7384_62294",
    result: "effect3_dropShadow_7384_62294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_7384_62294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7384_62294"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3.875,
    width: 13.75,
    height: 16.25,
    rx: 0.625,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.ecc9a633f38c759323548b8f33afda34.svg";
export { ForwardRef as ReactComponent };